export interface AlertProps {
    type: "danger"|"info"|"warn"|"success";
    message: React.ReactNode;
    className?: string;
}
export const Alert = ({type, message, className}: AlertProps) => {
    if (!message) return null;
    return (
        <div className={`alert alert-${type} alert-dismissible fade show my-1 ${className||''}`} role="alert">
            { message }
        </div>
    )
}